import { render, staticRenderFns } from "./PackageFeatures.vue?vue&type=template&id=3977e9fc&"
import script from "./PackageFeatures.vue?vue&type=script&lang=js&"
export * from "./PackageFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports